<script>
import TheMixin from "../mixin/TheFooter";
import { getStoreOption } from "@utils/ipetbooking-options";

export default {
  mixins: [TheMixin],
  computed: {
    storeItem() {
      return getStoreOption({
        value: this.$route.params.storeAlias,
        type: 'item'
      })
    },
  },
  methods: {
    openDialogStoreJtails(storeType) {
      this.$globalDialog('DialogStore', {
        activeTab: storeType,
        isQuerySet: true,
      })
    }
  },
}
</script>
<!-- section template -->
<template>
  <footer :class="$style.footer">
    <div class="footer__inner">
      <div class="container">
        <div class="footer__top row">
          <div class="col-md-7 col-xl-5">
            <div>
              <router-link :to="{ name: 'home' }" class="text-white fs-xl">
                {{ currentMerchant.title }}
              </router-link>
            </div>
            <ul :class="$style.contactList" class="mt-4">
              <li
                v-if="!!currentMerchant.phoneNumber"
                class="contactList__item"
              >
                <a
                  class="contactList__link"
                  :href="`tel:${ currentMerchant.phoneNumber }`"
                >
                  {{ currentMerchant.phoneNumber }}
                </a>
              </li>
              <li
                v-if="!!currentMerchant.email"
                class="contactList__item"
              >
                <a
                  class="contactList__link"
                  :href="`mailto:${ currentMerchant.email }`"
                  target="_blank"
                >
                  {{ currentMerchant.email }}
                </a>
              </li>
              <li
                v-if="!!currentMerchant.address"
                class="contactList__item"
              >
                <a
                  class="contactList__link"
                  :href="`https://www.google.com.tw/maps/search/${ currentMerchant.address }`"
                  target="_blank"
                >
                  {{ currentMerchant.address }}
                </a>
              </li>
            </ul>
          </div>
          <div class="col-3 d-none d-md-block">
            <h3 class="footer__menuTitle">
              服務條款
            </h3>
            <ul :class="$style.menuList">
              <li
                v-for="(termsMenuItem, index) in termsMenuList"
                :key="index"
                class="menuList__item"
              >
                <router-link
                  class="menuList__link"
                  :to="termsMenuItem.to"
                >
                  {{ termsMenuItem.title }}
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-2 d-none d-md-block">
            <template v-if="!!storeOpenOptions[0] && !!categoryAllOptions[0]">
              <h3 class="footer__menuTitle">
                相關服務
              </h3>
              <ul :class="$style.menuList">
                <li
                  v-for="(serviceMenuItem, index) in serviceMenuList"
                  :key="`serviceMenuList-${index}`"
                  class="menuList__item"
                >
                  <template v-if="serviceMenuItem.type === 'lightbox'">
                    <div
                      class="menuList__link"
                      :class="{ isActive: serviceMenuItem.data === storeItem.storeType }"
                      @click="openDialogStoreJtails(serviceMenuItem.data)"
                    >
                      {{ serviceMenuItem.title }}
                    </div>
                  </template>
                  <router-link
                    v-else
                    class="menuList__link"
                    :to="serviceMenuItem.to"
                  >
                    {{ serviceMenuItem.title }}
                  </router-link>
                </li>
              </ul>
            </template>
          </div>
          <div class="col-xl-2 d-none d-md-block">
            <ul :class="$style.socialList">
              <li
                v-if="!!currentMerchant.fbFanpageUrl"
                class="socialList__item"
              >
                <a
                  class="socialList__link"
                  :href="currentMerchant.fbFanpageUrl"
                  target="_blank"
                >
                  <i class="fontello fontello-db-facebook"></i>
                </a>
              </li>
              <li
                v-if="!!currentMerchant.lineId || !!currentMerchant.lineFriendUrl"
                class="socialList__item"
              >
                <div
                  class="socialList__link"
                  @click="openDialogLine"
                >
                  <i class="fontello fontello-line"></i>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <hr>
        <div class="footer__bottom">
          <span class="footer__copyright pb-md-0 pb-3">© {{new Date().getFullYear()}}  <a href="https://dingbeauty.com/" target="_blank">DING BEAUTY Inc.</a> <span
            class="footer__text"> All rights researved.</span></span>
          <span><span class="mx-1">DING BEAUTY </span><br class="d-block d-md-none">授權使用宣告</span>
        </div>
      </div>
    </div>
  </footer>
</template>
<!-- section style -->
<style lang="scss" module>
.footer {
  position: relative;
  z-index: 0;

  :global {
    hr {
      margin: 1.3rem 0;
    }

    .footer {
      &__logo {
        height: 66px;
        margin-top: -1.25rem;
        margin-bottom: 1.625rem;

        @include max-lg {
          margin-top: 0;
        }
      }

      &__inner {
        position: relative;
        padding: 5.625rem 4.375rem 7.25rem;
        background: #0C1C30;
        color: #fff;

        @include max-lg {
          padding: 3rem 4rem 6.25rem;
        }

        @include max-md {
          padding: 2rem 1rem 7rem;
          margin-bottom: -1rem;
          text-align: center;
        }

      }

      &__top {
        min-height: 15rem;

        @include max-lg {
          min-height: 0;
        }
      }

      &__bottom {
        display: flex;
        justify-content: space-between;
        font-size: 0.875rem;
        color: #fff;

        @include max-md {
          flex-direction: column;
          justify-content: center;
          font-size: 0.75rem
        }
      }

      &__copyright {
        color: #fff;
        a {
          @include link-unstyled;

          color: #fff;
          cursor: pointer;

          &:hover, &:focus {
            color: rgba($color: #fff, $alpha: 0.7)
          }
        }
      }

      &__menuTitle {
        margin-bottom: 1rem;
        font-size: 1rem;
        font-weight: 500;
      }

      &__text {
        @include max-lg {
          display: block;
          width: 100%;
          font-size: 0.75rem;
          letter-spacing: 1px
        }
      }
    }
  }
}

.contactList {
  @include list-unstyled;

  :global {
    .contactList {
      &__item {
        @include unstyled;
        color: #fff
      }

      &__link {
        @include link-unstyled;

        font-size: 0.875rem;
        line-height: 2;
        color: #fff;

        &:hover, &:focus {
          color: rgba($color: #fff, $alpha: 0.7)
        }
      }
    }
  }
}

.menuList {
  @include list-unstyled;

  :global {
    .menuList {
      &__item {
        @include unstyled;
      }

      &__link {
        @include link-unstyled;

        font-size: 0.875rem;
        line-height: 2;
        color: #fff;

        &:hover, &:focus {
          color: rgba($color: #fff, $alpha: 0.7)
        }
      }
    }
  }
}

.socialList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  :global {
    .socialList {
      &__item {
        &:not(:last-child) {
          margin-right: 1rem;
        }
      }

      &__link {
        @include link-unstyled;

        font-size: 2rem;
        color: #fff;
        cursor: pointer;

        &:hover, &:focus {
          color: rgba($color: #fff, $alpha: 0.7)
        }
      }
    }
  }
}
</style>
